// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Blog$BenfaerberBlog from "../lib/Blog.bs.js";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function Sidebar(props) {
  var match = React.useState(function () {
        return [];
      });
  var setRecentArticles = match[1];
  React.useEffect((function () {
          Blog$BenfaerberBlog.Api.getRecentArticles().then(function (r) {
                return Promise.resolve(setRecentArticles(function (param) {
                                return r;
                              }));
              });
        }), []);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("aside", {
                    children: [
                      JsxRuntime.jsx("p", {
                            children: "Recent Articles",
                            className: "menu-label"
                          }),
                      JsxRuntime.jsx("ul", {
                            children: Belt_Array.map(match[0], (function (article) {
                                    return JsxRuntime.jsx("li", {
                                                children: JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                                      children: article.title,
                                                      href: "/blog/" + article.slug
                                                    })
                                              }, article.slug);
                                  })),
                            className: "menu-list"
                          })
                    ],
                    className: "menu sidebar"
                  })
            });
}

var make = Sidebar;

export {
  s ,
  make ,
}
/* react Not a pure module */
